// extracted by mini-css-extract-plugin
export default {"CommunityGuidelines":"CommunityGuidelines_CommunityGuidelines__RedIB","nonBreakingHyphen":"CommunityGuidelines_nonBreakingHyphen__xJZNV"};